//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import QueryFilter from './QueryFilter';
import { mapGetters } from 'vuex';

export default {
    name: "AppCheckboxQueryFilter",
    extends: QueryFilter,
    data: () => ({
        isExpanded: false
    }),
    methods: {
        isChecked: function(option) {
            let checked = this.isFilterActive({ field: this.filter.field, value: option.identifier, operator: 'Equal' });
            //console.log("Checked: " + option.identifier + ": " + checked);
            return checked;
        },
        getIdentifier: function(option){
            var identifier = option.identifier;
            if (identifier.match(/^\d/)) {
                identifier = "filterOption" + identifier;
            }
            return identifier.replaceAll('.','').replaceAll(',','_');
        },
        handleKeyboard: function(){ 
            this.isExpanded = !this.isExpanded;
            if(this.isExpanded) {
                setTimeout(() => {
                    this.$refs.input[4].focus();
                }, 10);
            }
            else {
                    this.$refs.input[0].focus();
            }
            
        }
    },
    computed: {
        ...mapGetters(["isFilterActive"]),
        options() {
            return this.isExpanded ? this.filter.options : this.filter.options.slice(0, 4);
        }
    }
};
